import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { JwtHelperService } from "@auth0/angular-jwt";

import { AppInitializationService } from "app/app-initialization.service";
import { RequestResultModel } from "app/models/request-result.model";
import { LoginRequestModel } from "app/models/login-result.model";
import { reject } from "lodash";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Menu } from "app/models/menu.model";

@Injectable()
export class AccountService {

    public user: any;
    onChanged: BehaviorSubject<any>;

    public static get TokenStorageKey(): string {
        return "bb5de0fe-8d99-4430-840a-482fc05d71e3";
    }

    public get isAuthenticated(): boolean {
        var token = this._jwtHelperService.isTokenExpired();
        return !token;
    }

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
        private _jwtHelperService: JwtHelperService
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    public login(model: LoginRequestModel): Promise<RequestResultModel> {
        return new Promise<RequestResultModel>((resolve, reject) => {
            this._httpClient.post<RequestResultModel>(`${this.appConfigService.apiConfig["api-url"]}auth/login`,model).subscribe(async (res) => {
                    if (res.result === "Fail") {
                        reject(res);
                    }
                    if (res.result === "OK") {
                        localStorage.setItem(AccountService.TokenStorageKey,res.resultDescription);
                        await this.setTokenLocalStorage();
                        resolve(res);
                    }
                });
        });
    }

    public logout(): void {
        localStorage.removeItem(AccountService.TokenStorageKey);
        localStorage.clear();
        window.location.reload();
    }

    public async setTokenLocalStorage() {
        const token = this._jwtHelperService.decodeToken(
            localStorage.getItem(AccountService.TokenStorageKey)
        );
        localStorage.setItem("Username",token["unique_name"]);
        localStorage.setItem("CompanyID",token["company"]);
        localStorage.setItem("Contract",token["contract"]);
        localStorage.setItem("RoleID",token["role_id"]);
        localStorage.setItem("Active",token["active"]);
        localStorage.setItem("UserImage",token["user_image"])
        localStorage.setItem("UserID",token["nameid"]);

        var role = await this.getRols(token["role_id"])
        localStorage.setItem("RoleMenu",JSON.stringify(role));
    }

    public async getRols(rols): Promise<Array<Menu>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "menus/rolemenus/" + rols + '?companyId=' +localStorage.getItem('CompanyID'))
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
/*
    public getUser(userName): any {
        return new Promise<User>((resolve, reject) => {
            return this._httpClient.get(this.appConfigService.apiConfig["api-url"] +"users/getbyuser?username=" +userName).subscribe(async (res) => {
                this.user=res;
                    resolve(res);
                });
        });
    }*/
}
